import React, { useState } from 'react';
import { getTypeOfFile, onDownloadFile } from '../../../common/utils'
import { confirm } from 'devextreme/ui/dialog';
import config from '../../../common/config';
import './railActions.scss'

const sqdcp = ["Safety", "Quality", "Delivery", "Inventory", "Cost", "People"];
const stat = ["Not Started", "In Progress", "Completed"];
const pdca = ["Plan", "Do", "Check", "Act"];
const priority = ["High", "Medium", "Low"];

export const formActions = {
    colCount: 1,
    items: [
        {
        itemType: "group",
        colCount: 2,
        colSpan: 3,
        items: [
            "sqdcp",
            {
               dataField: "escTierId",
               editorType: "dxSwitch",
            },
            {
                dataField: "actions",
                editorType: "dxTextArea",
                colSpan: 2,
                editorOptions: {
                    height: '100px'
                }
            },
            {
                dataField: "notes",
                editorType: "dxTextArea",
                colSpan: 2,
                editorOptions: {
                    height: '100px'
                }
            },
            "startDate",
            "dueDate",
            "completedDate",
            {
                dataField: "priority",
                colSpan: 2,
                editorOptions: {
                    showClearButton: true
                }
            }, "status", "owner", "top3",
            {
                dataField: "moduleLink",
                colSpan: 2,
            },
            "lsImageName", 
            "imageName"
        ]
    }, 
    {
        itemType: "group",
        colCount: 2,
        colSpan: 2,
        visible: false,
        disabled: true,
        caption: "PDCA",
        items: [
        {
            dataField: "pdca",
            editorType: "dxRadioGroup",
            colSpan: 2,
            editorOptions: {
                layout: "horizontal"
            }
        },
        // {
        //     dataField: "plan",
        //     editorType: "dxTextArea",
        //     colSpan: 1,
        //     editorOptions: {
        //         height: 100
        //     }
        // },
        // {
        //     dataField: "do",
        //     editorType: "dxTextArea",
        //     colSpan: 1,
        //     editorOptions: {
        //         height: 100
        //     }
        // },
        // {
        //     dataField: "check",
        //     editorType: "dxTextArea",
        //     colSpan: 1,
        //     editorOptions: {
        //         height: 100
        //     }
        // },
        // {
        //     dataField: "act",
        //     editorType: "dxTextArea",
        //     colSpan: 1,
        //     editorOptions: {
        //         height: 100
        //     }
        // },
        ]
    }
    ]
};
export const GRID_CONFIG = {

    // Rail Grid Columns
    RAIL_GRID_COL_DEF: [
        {
            dataField: "id",
            caption: "ID",
            dataType: "number",
            fixed: true,
            allowEditing: false
        }, {
            dataField: "sqdcp",
            caption: "SQDICP",
            dataType: "string",
            lookup: { dataSource: sqdcp },
            filterValue: '',
            validationRules: [{
                type: "required"
            }]
        }, {
            dataField: "escTierId",
            caption: "Escalated",
            dataType: "number",
            visible: true
        }, {
            dataField: "tier",
            caption: "Tier",
            dataType: "number",
            validationRules: [{
                type: "required"
            }],
        }, {
            dataField: "actions",
            caption: "Actions",
            dataType: "string",
            validationRules: [{
                type: "required"
            }],
        }, {
            dataField: "notes",
            caption: "Notes",
            dataType: "string"
        }, {
            dataField: "startDate",
            caption: "Start Date",
            dataType: "date",
            validationRules: [{
                type: "required"
            }],
        }, {
            dataField: "dueDate",
            caption: "Due Date",
            dataType: "date",

            validationRules: [{
                type: "required"
            }],
        },
        {
            dataField: "completedDate",
            caption: "Completed Date",
            dataType: "date"
        },
        {
            dataField: "openAge",
            caption: "Open Age",
            dataType: "number",
            format: "#,##0",
            allowEditing: false
        },
        {
            dataField: "moduleLink",
            caption: "Related To",
            dataType: "string",
            visible: true,
            allowEditing: false,
        },
        {
            dataField: "rpsAction",
            caption: "RPSAction",
            dataType: "string",
            visible: true,
            allowEditing: false,
        },
        {
            dataField: "status",
            caption: "Status",
            dataType: "string",
            lookup: { dataSource: stat },
            validationRules: [{
                type: "required"
            }]
        }, {
            dataField: "owner",
            caption: "Owner",
            validationRules: [{
                type: "required"
            }]
        },
        // {
        //     dataField: "pdca",
        //     caption: "PDCA",
        //     dataType: "string",
        //     lookup: { dataSource: pdca },
        //     validationRules: [{
        //         type: "required"
        //     }]
        // }, 
        {
            dataField: "priority",
            caption: "Priority",
            dataType: "string",
            visible: false,
            lookup: { dataSource: priority }
        }, 
        // {
        //     dataField: "plan",
        //     caption: "Plan",
        //     cssClass: "WrappedColumn",
        //     dataType: "string",
        //     visible: false
        // }, {
        //     dataField: "do",
        //     caption: "Do",
        //     cssClass: "WrappedColumn",
        //     dataType: "string",
        //     visible: false
        // }, {
        //     dataField: "check",
        //     caption: "Check",
        //     cssClass: "WrappedColumn",
        //     dataType: "string",
        //     visible: false
        // }, 
        {
            dataField: "act",
            caption: "Act",
            cssClass: "WrappedColumn",
            dataType: "string",
            visible: false
        }, {
            dataField: "createdDate",
            caption: "Created",
            dataType: "date",
            format: "shortDateShortTime",
            visible: false
        }, {
            dataField: "createdBy",
            caption: "Created By",
            dataType: "string",
            visible: false
        }, {
            dataField: "modifiedDate",
            caption: "Modified",
            dataType: "date",
            format: "shortDateShortTime",
            visible: false
        }, {
            dataField: "modifiedBy",
            caption: "Modified By",
            dataType: "string",
            visible: false
        },
        {
            dataField: "top3",
            caption: "Today's Top 3 ",
            dataType: "string",
            lookup: { dataSource: [1, 2, 3] },
            visible: false

        }
    ],
    RAIL_GRID_CONFIG: {
        showBorders: true,
        noDataText: "No Actions",
        rowAlternationEnabled: true,
        allowColumnReordering: true,
        allowColumnResizing: true,
        columnResizingMode: "widget",
        columnAutoWidth: true,
        columnChooser: {
            enabled: true,
            allowSearch: true,
            mode: "select"
        },

        headerFilter: {
            visible: true
        },
        sorting: {
            mode: "multiple"
        },
        grouping: {
            contextMenuEnabled: true
        },
        searchPanel: {
            visible: true
        },
        scrolling: { showScrollbar: "always" },
        filterRow: {
            visible: true,
            applyFilter: "auto"
        },
        //export: {
        //    enabled: true,
        //    fileName: "Actions"
        //},
        editing: {
            mode: "popup",
            allowUpdating: true,
            allowAdding: true,
            allowDeleting: true,
            useIcons: true,
            popup: {
                title: "Action",
                showTitle: true,
                position: {
                    my: "center",
                    at: "center",
                    of: window
                },
            width: "50%",
            },
            form: config.DEV_DISPLAY_OPTIONS ? formActions : { ...formActions , items: formActions.items.slice(0, -1 )}
        },

        onToolbarPreparing: function (e) {
            var dataGrid = e.component;
            var toolbarItems = e.toolbarOptions.items;

            // Adds a new item
            toolbarItems.unshift({
                location: "after",
                widget: "dxButton",
                options: {
                    icon: "refresh",
                    hint: "Refresh",
                    onClick: function () {
                        dataGrid.refresh();
                    }
                }
            });
        }
    }
}

export const ViewFiles = ({ files, folderName, moreInfo, updateData, onRowUpdated }) => {
    const [fileList, setFiles] = useState(files ? files : [])
    const deleteFile = (obj, f, j) => {
        confirm("Are you sure you want to delete?", "Confirm changes").then((res) => {
            if (res) {
                let fileItems = [...fileList]
                fileItems.splice(j, 1);
                setFiles(fileItems)
                onRowUpdated(f)
                updateData(fileItems)
                return
            }
        })
    }

    const filesTpl = () => {
        if (fileList && fileList.length > 0) {
            return fileList.map((val, index) => {
                return <div key={index}>
                    <a style={{ cursor: 'pointer' }} className="clickable-hover" onClick={() => {
                        getTypeOfFile({ imageName: val, fileExtension: val.split('.')[1] }, folderName)
                    }}>{val}</a>
                    <i style={{ padding: "0px 8px" }} title="Download" className="fa fa-download pointer" onClick={() => onDownloadFile(val, folderName)}></i>
                    <i title="Delete" className="fas fa-trash pointer" onClick={() => deleteFile(moreInfo.data.data, val, index)} ></i>
                </div>
            })
        } else return 'No Attachments.';

    }
    return <span>{filesTpl()}</span>

}